export const normalizeCode = (val) =>
  val ? String(val).toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 3) : "";

export const makeCodeFromTitle = (title = "") => {
  const raw = String(title)
    .normalize("NFKD")
    .replace(/[^\w\s]/g, "");
  const onlyAZ09 = raw.replace(/[^A-Za-z0-9]/g, "");
  const base = normalizeCode(onlyAZ09);
  return base || "";
};

export const makeUniqueProjectCode = (title = "", takenCodes = []) => {
  const taken = new Set((takenCodes || []).map((c) => normalizeCode(c)));
  const base = makeCodeFromTitle(title);

  if (!taken.has(base)) return base;

  const first = base[0] || "P";
  const second = base[1] || "R";
  // const third = base[2] || "J";

  for (let i = 0; i < 26; i++) {
    const candidate = `${first}${second}${String.fromCharCode(65 + i)}`;
    if (!taken.has(candidate)) return candidate;
  }
  for (let i = 0; i < 10; i++) {
    const candidate = `${first}${second}${i}`;
    if (!taken.has(candidate)) return candidate;
  }

  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  for (let a = 0; a < alphabet.length; a++) {
    for (let b = 0; b < alphabet.length; b++) {
      for (let c = 0; c < alphabet.length; c++) {
        const candidate = `${alphabet[a]}${alphabet[b]}${alphabet[c]}`;
        if (!taken.has(candidate)) return candidate;
      }
    }
  }

  return "PRJ";
};